import Close from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  DialogTitle,
  FormControl,
  IconButton,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useForm } from 'react-hook-form';

const defaultValues = {
  title: '',
};

const MovementOperationInsertModal = ({
  open,
  handleClose,
  insertLoading,
  onInsert,
}) => {
  const [{ operationSettings }] = useCookies(['operationSettings']);

  const {
    handleSubmit,
    reset,
    register,
    formState: { errors, isSubmitted },
  } = useForm({ defaultValues });

  useEffect(() => {
    if (!open) {
      reset(defaultValues);
    }
  }, [open, reset]);

  const handleDetailsSubmit = data => {
    onInsert?.({
      zoneGuid: operationSettings?.defaultZone?.key,
      title: data.title?.trim() ?? '',
      voucherType: 0,
      storeID: 0,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{ direction: 'rtl', minWidth: '360px' }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: 16,
        }}
      >
        لطفا عنوان را انتخاب کنید
        <IconButton onClick={handleClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            pt: 1,
            minWidth: 300,
          }}
        >
          <FormControl variant="standard" sx={{ m: 2, minWidth: 280 }}>
            <TextField
              autoFocus
              label="عنوان"
              variant="standard"
              {...register('title', { required: 'عنوان الزامی است' })}
              error={isSubmitted ? !!errors.title : false}
              helperText={isSubmitted ? errors.title?.message : null}
            />
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          color="warning"
          variant="contained"
          onClick={handleSubmit(handleDetailsSubmit)}
          loading={insertLoading}
        >
          ساخت جابه‌جایی محصول
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default MovementOperationInsertModal;
